import script from "./FooterView.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterView.vue?vue&type=script&setup=true&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=3dbb7592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dbb7592"]])

export default __exports__